import './Math.extension.js'; // polyfill Babylon math classes
import { DracoDecoderSource } from './api.js';
import { Viewer } from './babylon/Viewer.js';
import { update_from_partial } from './babylon/utility/utils.js';
export * from './api.js';
export * from './common.js';
export * from './Math.js';
export * from './Interpolation.js';
export { CoroutineToken } from './CoroutineManager.js';
export * from './Types.js';
export * from './babylon/RenderLayer.js';
export { Observer } from './Observable.js';
const default_viewer_config = {
    headless: false,
    run_render_loop: true,
    draco_decoder: {
        wasmUrl: 'error',
        wasmBinaryUrl: 'error',
        fallbackUrl: 'error'
    },
    interaction_system_enabled: true,
    verbose_warnings: true,
    use_parallel_shader_compile: true,
    xr_compatible: false,
    enable_webgl_memory_tracker: false,
    anisotropic_filtering_level: 4
};
/**
 * Creates an instance of the viewer, this should only be done once.
 * @param canvas The canvas that will be used when rendering
 * @param draco_decoders Union of enum or custom configuration for source of draco decoders
 * @param config Configuration object
 * @param optional_features Used to enable and disable optional and experimental features.
 * @returns IViewer
 */
export function create_viewer(canvas, draco_decoders, config, optional_features) {
    const real_config = update_from_partial(default_viewer_config, config !== null && config !== void 0 ? config : {});
    // The urls from config.draco_decoder always takes precedence
    if (typeof draco_decoders === 'object') {
        real_config.draco_decoder = Object.assign({}, draco_decoders);
    }
    else {
        if (draco_decoders === DracoDecoderSource.IKEA_COM) {
            real_config.draco_decoder = {
                wasmUrl: 'https://www.ikea.com/addon-app/viewer/v1/draco_wasm_wrapper_gltf.js',
                wasmBinaryUrl: 'https://www.ikea.com/addon-app/viewer/v1/draco_decoder_gltf.wasm',
                fallbackUrl: 'https://www.ikea.com/addon-app/viewer/v1/draco_decoder_gltf.js'
            };
        }
        else if (draco_decoders === DracoDecoderSource.UNIVERSAL) {
            real_config.draco_decoder = {
                wasmUrl: 'https://stoviwernonprddraco.z16.web.core.windows.net/draco_wasm_wrapper_gltf.js',
                wasmBinaryUrl: 'https://stoviwernonprddraco.z16.web.core.windows.net/draco_decoder_gltf.wasm',
                fallbackUrl: 'https://stoviwernonprddraco.z16.web.core.windows.net/draco_decoder_gltf.js'
            };
        }
        else {
            console.error('Unhandled DracoDecoderSource value');
        }
    }
    return new Viewer(canvas, real_config, optional_features);
}
//# sourceMappingURL=index.js.map